import {
  AuditLogFilter,
  AuditLogSummaryDto,
  AuditLogTimelineDto,
  PagedResult,
} from "../interfaces/auditLog";
import { apiVariable } from "./apiVariable";

export const getAuditLogs = async (
  token: string | null | undefined,
  filter: AuditLogFilter
): Promise<PagedResult<AuditLogSummaryDto>> => {
  const params = new URLSearchParams();
  if (filter.table) params.append("table", filter.table);
  if (filter.user) params.append("user", filter.user);
  if (filter.from) params.append("from", filter.from);
  if (filter.to) params.append("to", filter.to);
  if (filter.page) params.append("page", filter.page.toString());
  if (filter.pageSize) params.append("pageSize", filter.pageSize.toString());

  const response = await fetch(`${apiVariable}/audit?${params.toString()}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) throw new Error("Failed to fetch audit logs");
  return response.json();
};

export const getAuditTimeline = async (
  token: string | null | undefined,
  table: string,
  key: string
): Promise<AuditLogTimelineDto[]> => {
  const response = await fetch(`${apiVariable}/audit/entity/${table}/${key}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) throw new Error("Failed to fetch audit timeline");
  return response.json();
};
